export default __webpack_public_path__ + "static/media/SeedX-sorter-machine-380x306.66cc9df5.png";